import { render, staticRenderFns } from "./reclamacionesAdd.vue?vue&type=template&id=9dfa8b84&"
import script from "./reclamacionesAdd.vue?vue&type=script&lang=js&"
export * from "./reclamacionesAdd.vue?vue&type=script&lang=js&"
import style0 from "./reclamacionesAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports